<template>
  <div id="AccountDetails" class="container account-details ad">
    <div class="row">
      <div class="col-lg-3 col-sm-12">
        <MyAccount />
      </div>
      <div class="col-lg-9 col-sm-12">
        <h1 id="accountDetailsTitle">
          {{ getContentItem("accountDetailsMenu") }}
        </h1>
        <div class="content-box accnt-details form-horizontal">
          <h2>
            Account Information
          </h2>

          <div class="container">
            <div class="row">
              <div class="col">
                <!--Dealer Code-->
                <AvailableDealerCodeSelector
                  :show-all-branches-option="false"
                  class="controls"
                  @selectDealerCode="SetUserDealerCode"
                />

                <!--Update, Reset buttons-->
                <div class="control-group">
                  <div class="controls pull-right">
                    <button
                      id="btnResetSession"
                      class="btn"
                      :disabled="isUserUpdating"
                      @click="ResetSession"
                    >
                      {{ UserUpdateButtonText }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row divider">
              <div class="col">
                <!--Name-->
                <div class="control-group">
                  <label class="control-label">
                    Name:
                  </label>
                  <span>{{ user.FirstName }} {{ user.LastName }}</span>
                </div>

                <!--Job Title-->
                <div class="control-group">
                  <label class="control-label">
                    Job Title:
                  </label>
                  <span id="jobTitle">{{ user.JobTitle }}</span>
                </div>

                <!--Job Role-->
                <div class="control-group">
                  <label class="control-label">
                    Job Role:
                  </label>
                  <span>{{ user.JobClass.Name }}</span>
                </div>

                <!--Email-->
                <div class="control-group">
                  <label class="control-label">
                    Email:
                  </label>
                  <span id="content2_0_maincontent_1_lblEmail">{{ user.Email }}</span>
                </div>

                <!--Password-->
                <div class="control-group">
                  <label class="control-label">
                    Password:
                  </label>
                  <a :href="accountDetailsSettings.ChangePasswordUrl" target="_blank">{{
                    getContentItem("changePassword") }}</a>
                </div>

                <!-- language -->
                <div class="control-group">
                  <label class="control-label">
                    Language:
                  </label>
                  <span>{{ user.LanguagePreference.Description }}</span>
                </div>

                <!--Edit button-->
                <div class="control-group">
                  <div class="first-column-controls">
                    <a class="btn" :href="accountDetailsSettings.EditAccountUrl" target="_blank"><i class="icon-edit" />&nbsp;Edit</a>
                  </div>
                </div>
              </div>
              <div class="col">
                <!--Updates options-->
                <div>
                  <div id="update-options">
                    <ul class="unstyled subnav-btns">
                      <li>
                        <router-link :to="{name: 'WarehouseShippingOptions'}" class="btn btn-large">
                          Update Shipping Options<i class="icon-play pull-right" />
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="{name: 'AddressBookList'}" class="btn btn-large">
                          Update Address Book<i class="icon-play pull-right" />
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="control-group">
                  <button class="btn btn-large" @click="toggleConfirmEmpty">
                    Empty Cart
                  </button>
                  <b-collapse id="confirmEmptyCart" v-model="showConfirmEmpty" class="ad__empty-cart-wrapper">
                    <p>
                      This will remove all items from your cart. Click 'Confirm' to continue.
                    </p>
                    <b-button
                      id="confirmEmptyCart-btn"
                      variant="danger"
                      size="sm"
                      @click="emptyCart"
                    >
                      <div v-if="!isEmptyingCart">
                        Confirm
                      </div>
                      <div v-else>
                        <loading-spinner />
                      </div>
                    </b-button>
                  </b-collapse>
                </div>
                <div v-if="userIsWebDeveloper" class="divider">
                  <div class="control-group">
                    <input
                      id="btnLocalServerCacheRemoval"
                      type="submit"
                      name="btnLocalServerCacheRemoval"
                      value="Clear TMS OemsReleased from cache"
                      class="btn btn-large"
                    >
                  </div>
                  <div class="control-group">
                    <input
                      id="btnDn7RewriteCacheRemoval"
                      type="submit"
                      name="btnDn7RewriteCacheRemoval"
                      :value="ClearCacheText"
                      class="btn btn-large"
                      @click="ClearDn7RewriteCache"
                    >
                  </div>                   
                  <div v-if="userIsOfflineOrderAdmin" class="control-group">
                    <form
                      :action="downloadOfflineOrdersAction"
                      method="POST"
                      target="_blank"
                    >
                      <input type="hidden" name="accountId" :value="activeAccountId">
                      <input type="hidden" name="userId" :value="user.UserId">
                      <input type="hidden" name="dealerCodes" :value="['all']">
                      <input 
                        id="btnDownloadOfflineOrders"
                        type="submit"
                        name="sourceName"
                        value="Download Offline Orders"
                        class="btn btn-large"
                      >
                    </form>
                  </div>            
                </div>
              </div>
            </div>
            <div v-if="userCanSendAlerts" class="row">
              <div class="col">
                <SendAlert/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery"
  import { mapGetters } from "vuex"

  import MyAccount from "@/components/SubMenus/MyAccount"
  import { UserService } from "@/services/UserService"
  import { Dn6Service } from "@/services/Dn6Service"
  import { OrderService } from "@/services/OrderService";
  import { sessionHelper } from "@/components/mixins/sessionHelper"
  import AvailableDealerCodeSelector from "@/components/Dropdowns/AvailableDealerCodeSelector"
  import { ShoppingCartService, ErrorLogService } from "@/services"
  import LoadingSpinner from "@/components/Elements/LoadingSpinner"
  import SendAlert from "@/components/SubMenus/SendAlert.vue"

  export default {
    components: {
      MyAccount,
      AvailableDealerCodeSelector,
      LoadingSpinner,
      SendAlert,
    },
    mixins: [sessionHelper],
    data: () => ({
      accountDetailsSettings: {},
      ClearCacheText: "Clear DN7 Url Rewrites from cache",
      showConfirmEmpty: false,
      isEmptyingCart: false,
      downloadOfflineOrdersAction: OrderService.getDownloadOfflineOrdersAction()
    }),
    computed: {
      ...mapGetters([
        "user", 
        "hasPermission", 
        "getContentItem", 
        "isUserUpdating",
        "cartSummary",
        "McfCostCenterId",
        "activeAccountId"
      ]),
      userIsOfflineOrderAdmin: function () {
        return this.hasPermission("CanDownloadOfflineOrders");
      },
      userIsWebDeveloper: function () {
        return this.hasPermission("IsWebDeveloper")
      },
      userCanSendAlerts() {
        return this.hasPermission("CanSendAlerts")
      },
      UserUpdateButtonText: function () {
        return this.isUserUpdating ? "Updating..." : "Reset Session"
      }
    },
    created () {
      UserService.AccountDetails().then(response => {
        this.accountDetailsSettings = response.data
      })
    },
    methods: {
      ResetSession: function (event) {
        location.reload(true)
      },
      SetUserDealerCode: function (selectedAvailableDealerCode) {
        if (selectedAvailableDealerCode.PrimaryDealerCode !== undefined) {
          var params = {};
          params.dealerCode = selectedAvailableDealerCode.PrimaryDealerCode;
          params.isDn6 = window.appGlobals.IS_DN6;
          params.sessionVarString = this.getSessionVarString(this.user.UserId);
          params.refreshAfterProcessing = true;
          this.$store.dispatch("UPDATE_DEALER_CODE", params);
        }
        $("#displayWithSubDealers span.selected-tag").addClass("dealerCodeDropdownText")
      },
      ClearDn7RewriteCache: function () {
        this.ClearCacheText = "Running..."
        Dn6Service.ClearDn7SiteCache().then(clearCacheResponse => {
          if (clearCacheResponse.data) {
            this.ClearCacheText = "Complete"
          } else {
            this.ClearCacheText = "Not cleared"
          }
        }).catch(err => {
          this.ClearCacheText = "Error"
          ErrorLogService.LogException(err)
        })
      },
      toggleConfirmEmpty() {
        this.showConfirmEmpty = !this.showConfirmEmpty;
      },
      async emptyCart() {
        try {
          this.isEmptyingCart = true;
          const params = {
            mcfCostCenterId: this.McfCostCenterId,
            accountId: this.activeAccountId,
            userId: this.user.UserId,
            shoppingCartId: this.cartSummary.Id
          };
          await ShoppingCartService.EmptyCart(params).then((result) => {
            this.$store.dispatch("LOAD_CART_SUMMARY", { accountId: this.activeAccountId, userId: this.user.UserId });
            this.isEmptyingCart = false;
            this.toggleConfirmEmpty();
          });
        } catch (err) {
          ErrorLogService.LogException(err);

          this.$store.commit("pushTimedMessage", {
            header: "Error emptying your cart.",
            message: "Please try again. If this error continues contact support.",
            IsError: true,
            seconds: 20,
          });
        }
      },
    },
  }
</script>
<style lang="scss">
  .ad__empty-cart-wrapper {
    padding: 0.5em;
    background-color: #f2d7d5;
    color: #621c18;
    border: 1px solid #621c18;
    border-radius: 5px;
    font-size: 12pt;
  }
</style>